import Immutable from 'seamless-immutable';
import ActionTypes from './../common/ActionTypes';

const DEFAULT_STATE = Immutable({
  isInitialized: false,
  isUserLoading: false,
  userError: '',
  isUserDeletingAccount: false,
  deleteAccountError: '',
  isProjectsLoading: false,
  isProjectsFailed: false,
  isCreatingOrUpdatingProject: false,
  isInviting: false,
  updatingInvitations: [],
  removingProjectMembers: [],
  isTeamMembersLoading: false,
  isTeamMembersFailed: false,
  isUpdatingTeamMember: false,
  isProjectsRecentActivityLoading: false,
  isProjectsRecentActivityFailed: false,
  isProjectsConnectActivityLoading: false,
  isProjectsConnectActivityFailed: false,
  isProjectsConnectActivityHasMore: false,
  isProjectsConnectActivityLoadingMore: false,
  dialog: undefined,
  isUpdateAvailable: false,
});

export default function(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {
    case ActionTypes.INITIALIZED:
      return state.merge({
        isInitialized: action.isInitialized,
      });
    case ActionTypes.USER_LOADING:
      return state.merge({
        isUserLoading: action.loading,
      });
    case ActionTypes.USER_ERROR:
      return state.merge({
        userError: action.error,
      });
    case ActionTypes.USER_DELETING_ACCOUNT:
      return state.merge({
        isUserDeletingAccount: action.isUserDeletingAccount,
      });
    case ActionTypes.DELETE_ACCOUNT_ERROR:
      return state.merge({
        deleteAccountError: action.error,
      });
    case ActionTypes.PROJECTS_LOADING:
      return state.merge({
        isProjectsLoading: action.loading,
      });
    case ActionTypes.PROJECTS_FAILED:
      return state.merge({
        isProjectsFailed: action.isFailed,
      });
    case ActionTypes.CREATING_OR_UPDATING_PROJECT:
      return state.merge({
        isCreatingOrUpdatingProject: action.isCreatingOrUpdatingProject,
      });
    case ActionTypes.INVITING_TEAM:
      return state.merge({
        isInviting: action.loading,
      });
    case ActionTypes.ADD_UPDATING_INVITATION:
      return state.setIn(
        ['updatingInvitations'],
        state.updatingInvitations.concat([action.email]),
        { deep: true },
      );
    case ActionTypes.REMOVE_UPDATING_INVITATION:
      return state.setIn(
        ['updatingInvitations'],
        state.updatingInvitations.filter(email => email !== action.email),
        { deep: true },
      );
    case ActionTypes.ADD_REMOVING_PROJECT_MEMBER:
      return state.setIn(
        ['removingProjectMembers'],
        state.removingProjectMembers.concat([action.email]),
        { deep: true },
      );
    case ActionTypes.REMOVE_REMOVING_PROJECT_MEMBER:
      return state.setIn(
        ['removingProjectMembers'],
        state.removingProjectMembers.filter(email => email !== action.email),
        { deep: true },
      );
    case ActionTypes.TEAM_MEMBERS_LOADING:
      return state.merge({
        isTeamMembersLoading: action.loading,
      });
    case ActionTypes.TEAM_MEMBERS_FAILED:
      return state.merge({
        isTeamMembersFailed: action.isFailed,
      });
    case ActionTypes.TEAM_MEMBER_UPDATING:
      return state.merge({
        isUpdatingTeamMember: action.isUpdating,
      });
    case ActionTypes.PROJECTS_RECENT_ACTIVITY_LOADING:
      return state.merge({
        isProjectsRecentActivityLoading: action.loading,
      });
    case ActionTypes.PROJECTS_RECENT_ACTIVITY_FAILED:
      return state.merge({
        isProjectsRecentActivityFailed: action.isFailed,
      });
    case ActionTypes.PROJECTS_CONNECT_ACTIVITY_LOADING:
      return state.merge({
        isProjectsConnectActivityLoading: action.loading,
      });
    case ActionTypes.PROJECTS_CONNECT_ACTIVITY_FAILED:
      return state.merge({
        isProjectsConnectActivityFailed: action.isFailed,
      });
    case ActionTypes.PROJECTS_CONNECT_ACTIVITY_HAS_MORE:
      return state.merge({
        isProjectsConnectActivityHasMore: action.hasMore,
      });
    case ActionTypes.PROJECTS_CONNECT_ACTIVITY_LOADING_MORE:
      return state.merge({
        isProjectsConnectActivityLoadingMore: action.loading,
      });
    case ActionTypes.SHOW_DIALOG:
      return state.merge({
        dialog: action.dialog,
      });
    case ActionTypes.UPDATE_AVAILABLE:
      return state.merge({
        isUpdateAvailable: action.isUpdateAvailable,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/uiState.js